import keyMirror from 'keymirror';

export default keyMirror({
    GET_BOOTSTRAP: null,
    GET_ENUMERATIONS: null,
    GET_REGIONS_BY_COUNTRY_COMPLETED: null,
});
